import { isFunction, isArray, isObject, pick, omit } from 'lodash'
import { EMPLOYEE_URL_MAP } from './utils/api'
import SingleComponent from './single'
import MultipleComponent from './multiple'

// props
import { EMPLOYEE_PROPS } from './props/employee'
import { COMMON_PROPS } from './props/common'
import { MULTIPLE_PROPS } from './props/multiple'
import Autocomplete from 'element-ui/lib/autocomplete'
const multipleProps = omit(MULTIPLE_PROPS, ['labelKeys'])

const autocompletePropsKeys = Object.keys(Autocomplete.props)

export default {
  name: 'KyeEmployee',
  reportName: 'KyeEmployee',
  props: {
    ...EMPLOYEE_PROPS,
    ...COMMON_PROPS,
    ...multipleProps
  },
  computed: {
    sourceConfig() {
      return EMPLOYEE_URL_MAP[this.$props.source || 'hr']
    },
    placeholderText() {
      return `字数不少于${this.$props.inputLength}`
    },
    labelKeys() {
      const { renderKeys } = this.sourceConfig
      return isArray(this.$props.keys) && this.$props.keys.length ? this.$props.keys : renderKeys
    },
    currentValueKey() {
      return this.$props.valueKey || this.sourceConfig.valueKey
    }
  },
  render(h) {
    const props = this.$props
    const autocompleteAttrs = pick(this.$attrs, autocompletePropsKeys)
    const commonAttrs = {
      props: {
        value: props.value,
        placeholder: props.placeholder,
        clearable: props.clearable,
        readonly: props.readonly,
        disabled: props.disabled,
        fetchSuggestions: this.handleFetchSuggestionsEvent,
        // 下拉框渲染的key的集合
        labelKeys: this.labelKeys,
        multipleLimit: props.multipleLimit,
        valueKey: this.currentValueKey,
        filterable: props.filterable,
        reserveKeyword: props.reserveKeyword,
        rowKey: props.rowKey,
        autocompleteAttrs,
        clearSelectByEmptySearch: props.clearSelectByEmptySearch,
        clearOptionsAfterBlur: props.clearOptionsAfterBlur
      },
      on: {
        input: this.handleInputEvent,
        focus: this.handleFocusEvent,
        blur: this.handleBlurEvent,
        select: this.handleSelectEvent,
        clear: this.handleClearEvent,
        change: this.handleChangeEvent,
        inputChange: (...arg) => this.$emit('inputChange', ...arg),
        'remove-tag': this.handleRemoveTagEvent
      },
      scopedSlots: this.$scopedSlots,
      ref: 'employeeRef'
    }
    if (props.multiple) {
      return <MultipleComponent {...commonAttrs}></MultipleComponent>
    } else {
      return <SingleComponent {...commonAttrs}></SingleComponent>
    }
  },
  methods: {
    // 删除已选的某一项，多选时触发
    handleRemoveTagEvent(val) {
      this.$emit('remove-tag', val)
    },
    // change事件-多选时触发
    handleChangeEvent(val) {
      this.$emit('change', val)
    },
    // 清除事件
    handleClearEvent() {
      this.$emit('clear')
      setTimeout(_ => {
        this.$parent.onFieldBlur && this.$parent.onFieldBlur()
      }, 300)
    },
    // 聚焦事件
    handleFocusEvent() {
      this.$emit('focus', this)
    },
    // 选择事件
    handleSelectEvent(val, arr) {
      if (!this.$props.multiple) {
        this.$emit('input', isObject(val) ? val[this.currentValueKey] : '')
      }
      this.$emit('select', val, arr)
    },
    // 输入事件
    handleInputEvent(val) {
      this.$emit('input', val)
      // 触发父级的清除校验，如果存在
      this.$parent.clearValidate && this.$parent.clearValidate()
    },
    // 失去焦点
    handleBlurEvent(val, e) {
      if (this.$props.warning) {
        if (val && val.length < +this.$props.inputLength) {
          this.$message.warning(this.placeholderText)
        }
      }
      this.$emit('blur', e, val)
      this.setCacheData(null)
      this.$parent.clearValidate && this.$parent.clearValidate()
      this.$parent.onFieldBlur && this.$parent.onFieldBlur()
    },
    // 请求数据之前的逻辑
    async handleFetchSuggestionsEvent(val) {
      // 有调用接口获取数据，并且搜索字段后有空格
      if (this.cacheData && val && /\S+\s+/.test(val)) {
        let value = val.trim().replace(/\s+/, ' ')
        let arr = value.split(' ')
        if (!arr[0] || arr[0].length < +this.$props.inputLength) {
          return null
        }
        if (arr[1] && this.cacheData && this.cacheData.length > 0) {
          let data = this.cacheData.filter(item => this.labelKeys.some(k => item[k].includes(arr[1])))
          return data
        } else if (!arr[1] && this.cacheData && this.cacheData.length > 0) {
          return this.cacheData || []
        }
      } else {
        if (val) {
          val = val.trim()
        }
        if (!val || val.length < this.$props.inputLength) {
          return null
        }
        const data = await this.fetchData(val)
        return data
      }
    },
    // 设置缓存数据
    setCacheData(data) {
      this.cacheData = data
    },
    // 请求数据
    async fetchData(val) {
      try {
        if (this.$props.options) {
          let data = []
          if (isFunction(this.$props.options)) {
            data = await this.$props.options(val)
          } else if (Array.isArray(this.$props.options)) {
            data = this.$props.options
          }
          const leng = data && data.length
          if (!leng) {
            if (this.$props.message !== '') {
              this.$message.warning({
                duration: 1000,
                message: this.$props.message
              })
            }
          }
          this.setCacheData(leng ? data : null)
          return data
        }
        const { url, formatParams, filterResult } = this.sourceConfig
        const filterOptionProp = this.$props.filterOptionProp
        const customUrl = this.$props.url
        const { status = '10', ...resetOptionProp } = filterOptionProp || {}
        // // 单个 leaderId duty jobType departmentId department  多个 duties jobTypes departmentIds departmentTypes
        const hrParams = {
          status,
          ...resetOptionProp
        }
        const params =
          customUrl && isFunction(this.$props.formatParams)
            ? this.$props.formatParams(val)
            : formatParams(val, +this.$props.inputLength, hrParams)
        const interfaceCode = customUrl || url
        let res = await this.$http(interfaceCode, params, this.$props.axios)
        if (isFunction(this.$props.formatResult)) {
          res = this.$props.formatResult(res, val, this)
        }
        let data = res && res.rows ? res.rows : res
        // 兜底
        if (!data) {
          data = []
        }
        // 接口数据，公共处理过滤的逻辑
        data = filterResult(data)
        if (this.$props.clearSelectByEmptySearch) {
          if (!data.length) {
            data = null
            if (this.$props.message !== '') {
              this.$message.warning({
                duration: 1000,
                message: this.$props.message
              })
            }
          }
        }
        this.setCacheData(data)
        return data || []
      } catch (err) {
        setTimeout(_ => {
          this.setCacheData(null)
          return []
        }, 500)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-employee/employee.js